var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 16,
    height: 3,
    fill: "#0C6564"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 16,
    height: 3,
    fill: "#0C6564"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 11.5,
    width: 16,
    height: 3,
    fill: "#0C6564"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridMenu);
export default __webpack_public_path__ + "static/media/grid-menu.c33a056f31f7e9cb3d975a37b7c90d0c.svg";
export { ForwardRef as ReactComponent };